module.exports = __webpack_public_path__ + "static/media/fi.0361140e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fi.svg
// module id = 2087
// module chunks = 0